<template>
  <el-dialog
      title="注册审核"
      :visible.sync="dialogVisible"
      width="600px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      append-to-body>
    <el-form ref="form" :model="form" label-width="100px">
      <el-radio-group v-model="form.radio">
        <el-radio :label="1">注册缴费</el-radio>
        <el-radio :label="2">不注册</el-radio>
        <el-radio :label="3">其他</el-radio>
        <el-radio :label="4">未知</el-radio>
      </el-radio-group>
    </el-form>
    <div class="flex-middle flex-center" style="margin-top: 20px">
<!--      <el-button plain @click="resetForm" v-show="status == 1">重置</el-button>-->
<!--      <el-button plain @click="dialogVisible = false;$emit('fetchData')">取消</el-button>-->
      <el-button type="primary" @click="submit" >确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Utils from "../../../assets/js/Utils";

export default {
  name: "RejectReasonDialog",
  props: ['successCallback'],
  data(){
    return{
      dialogVisible : false,
      form:{
        id:null,
        radio:''
      },
      // status: null,//1-填写驳回原因 2-查看驳回原因
    }
  },
  methods:{
    //保存
    submit(){
      axios.post(Urls.URL.data_url+'/'+this.form.id+'/updateRegist/'+this.form.radio).then(res => {
        this.dialogVisible = false
        this.$emit('fetchData')
      }).catch(err => {
        this.$alert(err.response.data.errorMessage || Utils.errorText)
      })
    },
    //重置数据
    resetForm() {
      this.form = Object.assign({})
      this.form.items = []
      this.form.id = this.dataId
    },
    // 显示弹出层
    async setMaskVisible(val, data , status) {
      // await this.fetchData()
      // this.allowAction = Utils.checkMenuOprate('enroll.data')
      this.dialogVisible = val
      this.form.id = data
      this.form.radio = status
      // this.status = status
      // 暴力深拷贝
      // let _obj = JSON.stringify(data);
      // this.form = JSON.parse(_obj);
      // 当对象中只有一级属性，没有二级属性的时候，此方法为深拷贝，但是对象中有对象的时候，此方法，在二级属性以后就是浅拷贝
      // this.form  = Object.assign({},data)
      // if(!this.form.id) {
      //   this.form.items = []
      // }
      // this.dataId = this.form.id
      // this.form  = Object.assign({},this.form)
    },
  }
}
</script>

<style scoped>

</style>